import React, { useRef } from 'react';
import { VirtualizedTreeListProvider } from 'shared/components/ui/virtualized-tree-list';
import { Trash as TrashFilterDocument } from 'shared/constants/filter-document';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';

import { PageTopBar } from './components/page-top-bar';
import * as Styled from './trash.style';

const noOrder = {};

export const Trash: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <Styled.Container>
      <Styled.Main>
        <VirtualizedTreeListProvider>
          <Styled.MainContent>
            <PageTopBar />
            <Styled.Content ref={scrollRef}>
              <ProvidedTaskFilterList
                scrollElement={scrollRef}
                filterDocument={TrashFilterDocument.defaultFilterDocument}
                defaultFilterDocument={
                  TrashFilterDocument.defaultFilterDocument
                }
                customOrder={noOrder}
              />
            </Styled.Content>
          </Styled.MainContent>
        </VirtualizedTreeListProvider>
      </Styled.Main>
    </Styled.Container>
  );
};
